import currency from 'currency.js';
export default function (price, precision = 0) {
    return currency(price, { separator: ' ', precision }).format();
}
